// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"b5999132","196":"7126c0ca","287":"782d1644","332":"765e64e1","693":"424cffff","845":"b8042613","983":"24da0d90"}[chunkId] + ".chunk.js";
};